import { EMPLOYEE_VIEW } from '@/fixtures'

export default {
  path: 'employee',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Employee',
      component: () => import('@/views/menus/Employee/Index'),
      meta: {
        permission: EMPLOYEE_VIEW
      }
    }
  ]
}
